var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMembersLogo1 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 40,
    fill: "none",
    viewBox: "0 0 121 40",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.638,
    d: "m45.055 36.554-15-34.788h4.694c.637 0 1.214.38 1.466.965l11.393 26.482c6.767-17.606 10.567-25.72 17.394-27.447l-15 34.788zM.535 36.237V1.77h4.15c.88 0 1.595.714 1.595 1.596v3.35c1.596-2.872 7.18-5.54 9.894-5.744 11.872-.894 14.734 9.84 14.68 15.32v19.946H25.27V16.29c.16-3.617-1.595-10.053-9.095-10.053-7.66 0-9.894 5.904-9.894 8.298v21.702zM57.027 27.298l4.788-10.692c-.777 13.66 9.32 22.489 21.769 13.705.62-.438 1.463-.425 2.04.069l2.36 2.024c-9.893 9.894-23.935 9.096-30.957-5.107ZM68.194 1.93l-4.628 10.373c5.798-8.474 13.812-8.361 20.429-3.145.822.648 2.015.622 2.739-.135l2.205-2.305C82.077.335 77.289-.782 68.194 1.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M115.272 32.186v4.468h5.266v-22.66c0-11.968-13.564-15-27.287-9.574l1.008 2.622c.338.88 1.27 1.38 2.193 1.194 13.075-3.539 18.66-1.624 18.82 8.27-18.67-3.99-25.053 2.275-25.053 10.573 0 9.255 15.159 15.48 25.053 5.107m-1.391-4.232c1.256-2.002 1.391-4.465 1.391-6.828v-.43c-15-3.552-20.105.5-19.148 7.34.71 5.084 12.956 7.57 17.757-.082",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.638,
    d: "M96.452 8.236c13.075-3.539 18.66-1.624 18.82 8.27-18.67-3.99-25.053 2.275-25.053 10.573 0 9.255 15.159 15.48 25.053 5.107v4.468h5.266v-22.66c0-11.968-13.564-15-27.287-9.574l1.008 2.622m2.193 1.194a1.94 1.94 0 0 1-2.193-1.194m2.193 1.194a1.94 1.94 0 0 1-2.193-1.194m21.013 13.654v.43c0 2.363-.135 4.826-1.391 6.828-4.801 7.653-17.047 5.166-17.757.083-.957-6.842 4.148-10.893 19.148-7.34Z"
  })));
};
export default SvgMembersLogo1;